export const CookieAcknowledge = 'CookieAcknowledge'
export const CookieManagePreferences = 'CookieManagePreferences'
export const CookieAcceptAll = 'CookieAcceptAll'
export const CookiePreferenceSave = 'CookiePreferenceSave'
